import React from 'react'
import {IconButton, makeStyles, Typography} from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(() => ({
    existPatient:{
        background:'#5571C6', 
        width:"100%", 
        paddingTop:"2px"
    },
    existPatientCheck:{
        display: "flex",
        alignItems:'center', 
        alignContent: 'center', 
        justifyContent:"space-between", 
        // cursor:'pointer'
    },
    existPatientHeader1:{
        fontSize: '24px', 
        fontFamily: 'Inter',
        color: '#fff',
        padding :"8px 10px",
        fontWeight: "450",
        lineHeight: 'auto'
    },
    headingText:{
        fontFamily: 'Inter',
        fontSize: '18px', 
        fontWeight: 700,
        color: '#000000'
    },
    subheadingText:{
        fontFamily: 'Inter',
        fontSize: '18px', 
        fontWeight: 600,
        color: '#000000'
    },
    normalText:{
        fontFamily: 'Inter',
        fontSize: '18px', 
        fontWeight: 400,
        color: '#000000',
        marginTop: '5px',
        lineHeight: 'auto',
        whiteSpace: 'normal',wordBreak: 'break-word'
    },
    container: {
        width: '100%',
    },
    alink:{
        fontFamily: 'Inter',
        fontSize: '18px', 
        fontWeight: 400,
        color: '#5571c6;',
        marginTop: '5px',
        textDecorationLine: 'underline',
        lineHeight: 'auto',
        whiteSpace: 'normal',wordBreak: 'break-word'
    }
}))
const IntakeTherapyModal = ({setOpenIntakeTherapyModal,setTherapyConsentStep,therapyConsentStep, setValue}) => {
    const classes = useStyles()
    return (
        <>
            <div>
                <div className={classes.existPatient}>
                    <div className={classes.existPatientCheck} style={{ padding: '0px 8px' }}>
                        <Typography className={classes.existPatientHeader1}>
                            Consent Form ({therapyConsentStep} of 2)
                        </Typography>
                        <IconButton
                            onClick={() => {
                                setOpenIntakeTherapyModal(false)
                                setTherapyConsentStep(1)
                                setValue()
                            }}>
                            <CloseIcon style={{ color: '#fff' }} />
                        </IconButton>
                    </div>
                </div>
                <div className="body">
                    <div>
                        <div className="card_content" style={{ padding: '15px' }}>
                            {therapyConsentStep === 1 && ( 
                                <div className="intake_form_container intakeformBox">
                                    <Typography className={classes?.headingText}>
                                        Consent for Therapy with an Associate Therapist
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I understand that I will be receiving therapy services from
                                        an Associate Therapist who is currently completing the
                                        required clinical hours to obtain full licensure as an
                                        independent therapist/counselor in the state of California.
                                        To meet the licensure requirements set by the California
                                        Board of Behavioral Sciences (BBS), Associate Therapists
                                        must complete 3,000 supervised hours under the guidance of a
                                        qualified clinical supervisor approved by the Board. This
                                        supervision is essential for professional development and
                                        progression toward independent licensure.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I acknowledge that therapy services will be based on a
                                        relationship built on trust and respect. Together, we will
                                        identify goals for therapy and work collaboratively toward
                                        achieving them. Sessions may involve exploring thoughts,
                                        emotions, personal history, communication patterns, beliefs,
                                        and areas for personal growth.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        As part of the training process, the Associate Therapist may
                                        consult with their supervisor regarding my case to ensure I
                                        receive the highest quality of care. Additionally, there may
                                        be occasions when a supervisor observes a portion of my
                                        therapy sessions for training and quality assurance
                                        purposes. Observations may occur in person or via a secure
                                        video link. The supervisor will not actively participate in
                                        the session but will provide feedback to support the
                                        therapist’s clinical growth. I will be informed in advance
                                        if a supervisor will be present in a session.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I understand that live observation enables the Associate
                                        Therapist to gain skills and allows their supervisor to
                                        assess, evaluate, and better understand their abilities.
                                        Both the Associate Therapist and their supervisor are bound
                                        by HIPAA and all applicable confidentiality laws. Any
                                        information shared during supervision or observation will
                                        remain strictly confidential and will only be used for
                                        professional development and supervisory purposes. No audio
                                        or video recording of these sessions will take place.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I have the right to decline observation at any time, and my
                                        decision will not impact my treatment. If an observation is
                                        scheduled, I will be informed in advance.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I have the right to know who is involved in my care. At the
                                        time of my appointment, I will be provided with the name and
                                        license number of the clinical supervisor for my reference.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        To ensure I am comfortable with my provider, I also have the
                                        ability to review a full list of providers by visiting:{' '}
                                        <a
                                            className={classes?.alink}
                                            href="https://www.telemed2u.com/our-providers"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            Our Providers
                                        </a>
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        By signing below, I acknowledge that I have read and
                                        understood this consent form and agree to receive therapy
                                        services from an Associate Therapist under supervision. I
                                        agree that my electronic signature on this application is
                                        binding and enforceable, as if I had signed a paper copy.
                                    </Typography>
                                </div>
                            )} 
                            {therapyConsentStep === 2 && (
                                <div className="intake_form_container intakeformBox">
                                    <Typography className={classes?.headingText}>
                                        Psychotherapy Consent
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I, the patient, consent to participate in telemental health
                                        services with a TeleMed2U provider as part of my
                                        psychotherapy. I understand that telemental health involves
                                        the delivery of clinical health care services through
                                        technology-assisted communication between a provider and a
                                        patient in different locations.
                                    </Typography>
                                    <Typography className={classes?.subheadingText}>
                                        I understand the nature of counseling:
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        The scope and type of counseling services I receive will be
                                        determined through an initial assessment and collaborative
                                        discussion with my provider. Counseling is a structured
                                        process designed to support personal growth, enhance
                                        emotional well-being, and improve interpersonal
                                        relationships. Research indicates that counseling can lead
                                        to increased self-awareness, improved coping strategies, and
                                        a greater ability to navigate life’s challenges.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        While counseling offers many benefits, including greater
                                        emotional resilience and personal insight, it may also bring
                                        about difficult emotions as I confront personal experiences
                                        and patterns. Emotional discomfort, temporary distress, or
                                        shifts in relationships may occur as part of the therapeutic
                                        process. My provider will work with me to navigate these
                                        challenges and develop strategies to promote positive change
                                        while minimizing potential risks.
                                    </Typography>
                                    <Typography className={classes?.subheadingText}>
                                        I understand the following with respect to telemental
                                        health:
                                    </Typography>
                                    <ol>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Information About Your Provider – a provider will be
                                                assigned to you based on your needs and treatment
                                                goals to ensure alignment with the provider’s area
                                                of expertise. You may or may not continue with the
                                                same therapist after your intake is complete, as
                                                your ongoing provider will be determined based on
                                                clinical considerations and your preferences.
                                                TeleMed2U has both independently licensed therapists
                                                and associate therapists. If you are scheduled with
                                                an associate therapist, you will be required to sign
                                                an additional consent form acknowledging their
                                                supervision process.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Right to Withdraw Consent – I have the right to
                                                withdraw consent for telemental health services at
                                                any time without affecting my right to future care,
                                                services, or program benefits to which I would
                                                otherwise be entitled.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Risks and Benefits – I understand there are
                                                potential risks, benefits, and consequences
                                                associated with telemental health, including but not
                                                limited to technical disruptions, confidentiality
                                                breaches, and limitations in responding to
                                                emergencies.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Confidentiality & Recording – I understand that
                                                neither party will record any of the online
                                                sessions. All information shared during sessions and
                                                any written records related to those sessions are
                                                confidential and will not be disclosed to anyone
                                                without written consent, unless disclosure is
                                                required or permitted by law.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Minors & Confidentiality – If I am under 18, the
                                                same privacy laws apply, with mandated reporting
                                                exceptions as detailed below.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Privacy Laws & Exceptions – The privacy laws
                                                protecting my protected health information (PHI)
                                                apply to telemental health unless an exception
                                                applies, such as mandatory reporting for abuse, risk
                                                of harm to self or others, or involvement in legal
                                                proceedings.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Confidentiality and Duty to Warn – Discussions
                                                between a provider and a patient are confidential.
                                                Under the Health Insurance Portability and
                                                Accountability Act (HIPAA), my private information
                                                cannot be shared without my written consent. This
                                                means that what I share with my provider remains
                                                private unless I sign a document authorizing
                                                disclosure to a specific person (e.g., a family
                                                member or another doctor).
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Privacy and My Session Environment – Because
                                                telemental health does not occur in person, I
                                                understand that I am responsible for ensuring a
                                                private and secure session environment. TeleMed2U
                                                providers take reasonable steps to protect my
                                                privacy, but I should also find a confidential space
                                                where I will not be interrupted or overheard.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Drug and Alcohol Use – My provider and I have the
                                                right to expect that our sessions will occur while
                                                both parties are not under the influence of any
                                                substance (prescribed, over-the-counter,
                                                unprescribed, legal, recreational, or illegal). If a
                                                party appears impaired, the session may be
                                                terminated, and an incident report will be submitted
                                                for further review. If substance use is a factor in
                                                treatment, my provider will work with me to develop
                                                a plan to address it within the safety planning
                                                discussion.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Session Environment & Driving – I should have a safe
                                                and quiet space for sessions, ensuring there are no
                                                distractions or third-party interruptions. Both my
                                                provider and I should position our cameras at eye
                                                level for clear visibility and effective
                                                communication. Sessions can take place while using a
                                                phone in the event of technical disruptions, and no
                                                one should actively drive during a session for
                                                safety reasons and compliance with distracted
                                                driving laws.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Respectful Conduct – TeleMed2U expects all
                                                interactions to be based on mutual respect,
                                                fostering a trusting and collaborative relationship
                                                between patients, providers, and staff. Disruptive,
                                                disrespectful, or discriminatory behavior will not
                                                be tolerated and may result in the termination of
                                                services.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Crisis management and intervention – Telemental
                                                health services are not appropriate for individuals
                                                in crisis who require a high level of support and
                                                intervention. My provider will assess whether I am a
                                                suitable candidate for telemental health services.
                                                If I later experience a crisis, my provider will
                                                implement an emergency plan to address the situation
                                                and may refer me to a higher level of care.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Emergency Communications – Telemental health
                                                services are not intended for medical or mental
                                                health emergencies. I should not delay seeking
                                                medical attention based on my sessions. If I believe
                                                I am experiencing an emergency, I should call 911 or
                                                988 (Mental Health Crisis Line) immediately. If, at
                                                any time during a session, I experience a medical or
                                                mental health crisis that cannot be managed
                                                remotely, my provider may determine that telemental
                                                health services are no longer appropriate. In this
                                                case, I may be instructed to seek in-person care,
                                                and my provider may contact emergency services or my
                                                identified emergency contact if necessary.
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Patient Feedback – TeleMed2U strives to provide
                                                high-quality care and may follow up after my
                                                appointment for feedback. If I have concerns, I can
                                                contact TeleMed2U at 512-382-1933 or via email at{' '}
                                                <a
                                                    className={classes?.alink}
                                                    href="mailto:info@telemed2u.com">
                                                    info@telemed2u.com
                                                </a>
                                                . If a CalOptima patient, contact 562-268-0955 or
                                                via email at{' '}
                                                <a
                                                    className={classes?.alink}
                                                    href="mailto:caloptimabh@telemed2u.com">
                                                    caloptimabh@telemed2u.com
                                                </a>
                                                .
                                            </Typography>
                                        </li>
                                        <li className={classes?.normalText}>
                                            <Typography className={classes?.normalText}>
                                                Appointment Reminders – TeleMed2U uses email, text,
                                                and phone call reminders for appointments. I may
                                                request my provider or customer service to change my
                                                preferences at any time.
                                            </Typography>
                                        </li>
                                    </ol>
                                    <Typography className={classes?.subheadingText}>
                                        Why do I need to sign this if I am not getting therapy from
                                        you?
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        While you may not be receiving therapy at this moment,
                                        signing this consent form is necessary in case you and your
                                        provider decide to include therapy as part of your
                                        personalized treatment plan in the future. If therapy is
                                        added, it will be provided by one of our licensed
                                        therapists, and having this consent on file ensures we can
                                        proceed with treatment.
                                    </Typography>
                                    <Typography className={classes?.normalText}>
                                        I agree that my electronic signature on this application is
                                        binding and enforceable, as if I had signed a paper copy.
                                    </Typography>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default IntakeTherapyModal